/**
 *  @class
 *  @function Listcollections
 */
if (!customElements.get("list-collections")) {
  class Listcollections extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setAnimations();
      this.observeCarouselSize();

      if (Shopify.designMode) {
        this.addEventListener("shopify:section:load", (event) => {
          this.setAnimations();

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        });
      }
    }
    disconnectedCallback() {
      this._carouselResizeCleanup?.();
      this._carouselResizeCleanup = null;
    }
    observeCarouselSize() {
      const carousel = this.querySelector("slide-show.collection-grid--carousel");
      if (!carousel || !window.ResizeObserver) return;

      let width = -1;
      let pending = false;
      let resizeFrame = 0;
      let arrowFrame = 0;
      let instance;
      const schedule = () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(refresh);
      };
      const onSettled = () => {
        if (pending) schedule();
      };
      const onResized = () => {
        pending = false;
        cancelAnimationFrame(arrowFrame);
        arrowFrame = requestAnimationFrame(() => {
          if (this.isConnected) carousel.setArrowsState?.(instance);
        });
      };
      const unbind = () => {
        instance?.off("settle", onSettled);
        instance?.off("resize", onResized);
      };
      const refresh = () => {
        if (!this.isConnected) return;
        const current = window.Flickity?.data(carousel);
        if (!current) return;
        if (current !== instance) {
          unbind();
          instance = current;
          instance.on("settle", onSettled);
          instance.on("resize", onResized);
        }
        // Flickity can defer this while moving; retry on its settle event.
        instance.resize();
      };
      const observer = new ResizeObserver(([entry]) => {
        if (Math.abs(entry.contentRect.width - width) < .5) return;
        width = entry.contentRect.width;
        pending = true;
        schedule();
      });
      observer.observe(carousel);
      customElements.whenDefined("slide-show").then(() => {
        if (!this.isConnected) return;
        pending = true;
        schedule();
      });
      this._carouselResizeCleanup = () => {
        observer.disconnect();
        cancelAnimationFrame(resizeFrame);
        cancelAnimationFrame(arrowFrame);
        unbind();
      };
    }
    setAnimations() {
      ScrollTrigger.batch(this.querySelectorAll(".collection-card--image-image"), {
        start: "top 90%",
        onEnter: (elements, triggers) => {
          gsap.fromTo(
            elements,
            {scale: 1.15},
            {
              scale: 1,
              opacity: 1,
              stagger: 0.15,
              ease: window.theme.settings.animation_easing,
              clearProps: "transform",
            }
          );
        },
      });
    }
  }
  customElements.define("list-collections", Listcollections);
}
